import Card from 'antd/lib/card';
import Spin from 'antd/lib/spin';
import React from 'react';
import {
    displayNameForIntegrationType,
    iconAndAltForIntegrationType,
    isBetaForIntegrationType,
} from '../../helpers/integrationHelpers';
import { IntegrationType } from '../../types';
import Text from 'antd/lib/typography/Text';
import { BetaBadge } from '@/components/automations/AppAutomationSettings';
import Space from 'antd/lib/space';

interface ConnectAvailableIntegrationComponentProps {
    connectButton: React.ReactNode;
    integrationType: IntegrationType;
    isLoading: boolean;
    shouldUseSmallGrid?: boolean;
}

const ConnectAvailableIntegrationComponent: React.FC<ConnectAvailableIntegrationComponentProps> = (props) => {
    const { integrationType, connectButton, isLoading, shouldUseSmallGrid } = props;
    const displayName = displayNameForIntegrationType(integrationType);

    const [icon, alt] = iconAndAltForIntegrationType(integrationType);

    return (
        <Spin spinning={isLoading} size="small">
            <Card bodyStyle={{ padding: shouldUseSmallGrid ? 12 : 24 }}>
                <div
                    style={
                        shouldUseSmallGrid ?
                            {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }
                        :   { display: 'flex', flexDirection: 'column', justifyContent: 'center' }
                    }
                >
                    {shouldUseSmallGrid ?
                        <>
                            <Space>
                                {icon && <img src={icon} alt={alt} width={30} height={30} />}
                                <Text style={{ textAlign: 'center' }}>{displayName}</Text>
                            </Space>
                            {isBetaForIntegrationType(integrationType) && <BetaBadge />}
                            {connectButton}
                        </>
                    :   <>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: 40,
                                    justifyContent: 'center',
                                    flexWrap: 'wrap',
                                    gap: '8px',
                                }}
                            >
                                {icon && <img src={icon} alt={alt} width={30} height={30} />}
                                <Text style={{ textAlign: 'center' }}>{displayName}</Text>
                                {isBetaForIntegrationType(integrationType) && <BetaBadge />}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
                                {connectButton}
                            </div>
                        </>
                    }
                </div>
            </Card>
        </Spin>
    );
};

export default ConnectAvailableIntegrationComponent;
